import { CircularProgress, TableCell, TableRow } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { InlineHint } from "../UIToolkit/molecules/InlineHint";
import SystemButton from "../UIToolkit/SystemButton/SystemButton";

type Props = {
	columnCount: number;
	/** `loading`: the breakdown is on its way. `error`: the fetch failed; `onRetry` offers it again. */
	status: "loading" | "error";
	onRetry?: () => void;
};

/** The breakdown's row while it loads, or when it could not be loaded. */
export const BreakdownStatusRow: FC<Props> = ({ columnCount, status, onRetry }) => {
	const { t } = useTranslation();
	if (status === "loading") {
		return (
			<TableRow>
				<TableCell colSpan={columnCount} sx={{ textAlign: "center", py: 2 }}>
					<CircularProgress size={20} />
				</TableCell>
			</TableRow>
		);
	}
	return (
		<TableRow data-testid="wage-breakdown-error">
			<TableCell colSpan={columnCount} sx={{ py: 1.5 }}>
				<InlineHint
					tone="warning"
					action={
						onRetry ? (
							<SystemButton buttonVariant="borderless" size="compact" noFullWidthMobile onClick={onRetry} data-testid="wage-breakdown-retry">
								{t("wageBreakdown.retry")}
							</SystemButton>
						) : undefined
					}
				>
					{t("wageBreakdown.loadError")}
				</InlineHint>
			</TableCell>
		</TableRow>
	);
};
